export default "__VITE_ASSET__DSxMlwd$__"